"use strict";
exports.__esModule = true;
exports.SvgFileAttachmentsMsExcel = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgFileAttachmentsMsExcel = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("g", { fillRule: "nonzero", fill: "none" },
        react_1["default"].createElement("path", { fill: "#107C41", d: "M1.667 0h16.666C19.253 0 20 .746 20 1.667v16.666c0 .92-.746 1.667-1.667 1.667H1.667a1.67 1.67 0 01-1.179-.488A1.67 1.67 0 010 18.333V1.667C0 .747.746 0 1.667 0z" }),
        react_1["default"].createElement("path", { fill: "#FFF", d: "M5.625 15l3.17-5.014L5.89 5h2.336l1.585 3.187c.146.302.246.528.3.676h.021c.105-.241.214-.476.328-.704L12.155 5H14.3l-2.978 4.958L14.375 15h-2.281l-1.831-3.5a3.018 3.018 0 01-.219-.468h-.027a2.15 2.15 0 01-.212.453L7.92 15H5.625z" })))); };
//# sourceMappingURL=FileAttachmentsMsExcel.js.map